'use strict';

const addClass = ($el, className) => {
  oneOrMany($el, className, 'add');
};

const addClassToNextItem = ([...target], className) => {
  const index = target.findIndex(element => element.classList.contains(className));
  if (index > -1) {
    target[index].classList.remove(className);
  }
  const fallbackIndex = index + 1 < target.length ? index + 1 : 0;
  target[index === -1 ? 0 : fallbackIndex].classList.add(className);
};

const removeClass = ($el, className) => {
  oneOrMany($el, className, 'remove');
};

const delay = time => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), time);
  });
};

const oneOrMany = (target, className, action) => {
  if (!target) {
    return;
  }
  if (target.length) {
    target.forEach(element => element.classList[action](className));
  } else {
    target.classList[action](className);
  }
};

export { addClass, addClassToNextItem, delay, removeClass };
